import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import SmallPopupTemplate from "components/templates/modal/small/SmallPopupTemplate";
import UsageSignupContent from "../../usage/signup/UsageSignupContent";
import * as s from "./UpgradeCycleModalStyled";
import { UsageSignupFlow } from "../../usage/signup/useUsageSignupFlow";
import { BILLING_CYCLE } from "api/interfaces/subscription.interface";
import { isYearlyBillingCycle } from "utils/priceUtils";

type Props = {
  currentCycle: BILLING_CYCLE;
  flow: UsageSignupFlow;
  onModal: () => void;
  onConfirmToMonthly: () => void;
};

export default function UpgradeCycleModalPresenter(props: Props): JSX.Element {
  if (isYearlyBillingCycle(props.currentCycle)) {
    return (
      <SmallPopupTemplate
        title={"Switch to Monthly Plan"}
        subTitle={"Would you like to switch to Monthly billing?"}
        cancel={true}
        confirmLabel="Switch to Monthly"
        onModal={props.onModal}
        onClick={props.onConfirmToMonthly}
      >
        <s.ConfirmBody>
          <div className="headline">
            You are about to change your billing cycle to <b>Monthly</b>.
          </div>
          <div className="detail">
            You can upgrade back to <b>Yearly</b> at any time.
          </div>
        </s.ConfirmBody>
      </SmallPopupTemplate>
    );
  }

  return (
    <BigPopupTemplate title={`Purchase Yearly Plan`} onModal={props.onModal}>
      <s.Body>
        <UsageSignupContent
          flow={props.flow}
          showTitle={false}
          onAddPayment={props.flow.actions.onAddPayment}
        />
      </s.Body>
    </BigPopupTemplate>
  );
}
